module.exports = __webpack_public_path__ + "img/arm-left-back.71348703.png";